import {makeVar} from "@apollo/client";

/**
 * Communicates form data with payment card
 */
export const contactReviewFormState = makeVar(null);